<template lang="">
  <Toast />
  <h4>Ticket #{{ uid }}</h4>
  <Timeline :value="events" layout="horizontal" style="text-align:center">
    <template #marker="slotProps">
      <span
        class="custom-marker"
        :style="{ backgroundColor: slotProps.item.color }"
      >
      </span>
    </template>
    <template #content="slotProps" style="text-align:center">
      {{ slotProps.item.status }}
    </template>
  </Timeline>
  <div class="grid">
    <div class="col-8">
      <div class="grid custom-background">
        <div class="col-12 header">
          <h6>{{ $t("tickets.requestHistory") }}</h6>
        </div>
        <div class="col-12 md:col-4" v-if="ticket.status != 3">
          <div class="p-inputgroup">
            <InputText
              :placeholder="addCommentPlaceholder"
              v-model="commentBody"
              :class="{ 'p-invalid': isInputInvalid }"
            />
            <Button
              :label="$t('assistance.placeholderSubmit')"
              @click="addComment"
            />
          </div>
          <p class="warning-message" v-if="isInputInvalid">
            {{ this.$t("tickets.nullCommentBody") }}
          </p>
        </div>
        <div class="col-12">
          <TicketHistory
            :history="ticket.history"
            :comments="ticket.comments"
            :ticketOwnerId="ticket.owner['_id']"
          />
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="grid custom-background">
        <div class="col-12 header">
          <h6>{{ $t("tickets.requestDetail") }}</h6>
        </div>
        <div class="col-6">
          <b>Ticket {{ $t("tickets.idHeader") }}:</b>
          <p>{{ ticket.uid }}</p>
        </div>
        <div class="col-6">
          <b>{{ $t("tickets.statusLabel") }}:</b>
          <p>{{ $t("tickets." + getStatusLabel(ticket.status)) }}</p>
        </div>
        <div class="col-6">
          <b>{{ $t("tickets.createdHeader") }}:</b>
          <p>
            {{ new Date(ticket.date).toLocaleDateString() }}<br />
            {{ new Date(ticket.date).getHours() }}:{{
              new Date(ticket.date).getMinutes()
            }}
          </p>
        </div>
        <div class="col-6">
          <b>{{ $t("tickets.updatedHeader") }}:</b>
          <p v-if="ticket.updated">
            {{ new Date(ticket.updated).toLocaleDateString() }}<br />
            {{ new Date(ticket.updated).getHours() }}:{{
              new Date(ticket.updated).getMinutes()
            }}
          </p>
          <p v-if="!ticket.updated">-</p>
        </div>
        <div class="col-12">
          <b>{{ $t("ticket.subjectHeader") }}:</b>
          <p>{{ parseHtmlIssue(ticket.subject) }}</p>
        </div>
        <div class="col-12">
          <b>{{ $t("ticket.issueHeader") }}:</b>
          <p>{{ parseHtmlIssue(ticket.issue) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TicketService from "../service/TicketService";
import TicketHistory from "../components/tickets/TicketHistory.vue";

export default {
  components: {
    TicketHistory,
  },
  data() {
    return {
      addCommentPlaceholder: this.$t("tickets.addCommentPlaceholder"),
      addCommentButton: this.$t("tickets.addCommentButton"),
      addCommentSuccess: this.$t("tickets.addCommentSuccess"),
      addCommentFailed: this.$t("tickets.addCommentFailed"),
      addCommentSuccessDetail: this.$t("tickets.addCommentSuccessDetail"),
      addCommentFailedDetail: this.$t("tickets.addCommentFailedDetail"),
      commentBody: null,
      submittingComment: false,
      uid: this.$route.params.uid,
      loading: false,
      events: [
        { status: this.$t("tickets.statusNew"), date: "-", color: "#C4CCD4" },
        { status: this.$t("tickets.statusOpen"), date: "-", color: "#C4CCD4" },
        {
          status: this.$t("tickets.statusPending"),
          date: "-",
          color: "#C4CCD4",
        },
        {
          status: this.$t("tickets.statusClosed"),
          date: "-",
          color: "#C4CCD4",
        },
      ],
    };
  },
  computed: {
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    ticket: function() {
      return this.$store.state.tickets.ticketsList.find(
        (ticket) => ticket.uid == this.uid
      );
    },
    isInputInvalid: function() {
      return !this.commentBody && this.submittingComment ? true : false;
    },
  },
  created() {
    this.ticketsService = new TicketService();
  },
  mounted() {
    this.extractEvents();
  },
  methods: {
    extractEvents() {
      let history = this.ticket.history;
      history.forEach((event) => {
        switch (event.action) {
          case "ticket:created": {
            this.events[0].date = new Date(event.date).toLocaleDateString();
            this.events[0].color = "#00434D";
            break;
          }
          case "ticket:set:status:1": {
            this.events[1].date = new Date(event.date).toLocaleDateString();
            this.events[1].color = "#00434D";
            break;
          }
          case "ticket:set:status:2": {
            /*  tickets can pass from created to status:2 without passing from status:1
                            therefore we need to mark the skipped step
                        */
            this.events[1].date = new Date(event.date).toLocaleDateString();
            this.events[1].color = "#00434D";
            this.events[2].date = new Date(event.date).toLocaleDateString();
            this.events[2].color = "#00434D";
            break;
          }
          case "ticket:set:status:3": {
            /*  tickets can pass from created to status:3 without passing from status:1 and 2
                            therefore we need to mark the skipped steps
                        */
            this.events[1].date = new Date(event.date).toLocaleDateString();
            this.events[1].color = "#00434D";
            this.events[2].date = new Date(event.date).toLocaleDateString();
            this.events[2].color = "#00434D";
            this.events[3].date = new Date(event.date).toLocaleDateString();
            this.events[3].color = "#00434D";
            break;
          }
        }
      });
    },
    async addComment() {
      this.submittingComment = true;
      if (this.commentBody) {
        let response = await this.ticketsService.sendComment(
          this.access_token,
          this.commentBody,
          this.ticket["_id"]
        );
        if (response.success) {
          this.substituteTicketInStoreWithNewFromResponse(response.ticket);
          this.$toast.add({
            severity: "success",
            summary: this.addCommentSuccess,
            detail: this.addCommentSuccessDetail,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: this.addCommentFailed,
            detail: this.addCommentFailedDetail,
            life: 3000,
          });
        }
        this.submittingComment = false;
      }
      setTimeout(() => {
        this.submittingComment = false;
      }, 3000);
      this.commentBody = null;
    },
    getStatusLabel(status) {
      switch (status) {
        case 0:
          return "statusNew";
        case 1:
          return "statusOpen";
        case 2:
          return "statusPending";
        case 3:
          return "statusClosed";
      }
    },
    parseHtmlIssue(issue) {
      issue = issue.replace(/(<([^>]+)>)/g, "\n");
      return issue;
    },
    substituteTicketInStoreWithNewFromResponse(ticket) {
      this.$store.commit("tickets/updateTicketsListAfterAddingComment", ticket);
    },
  },
};
</script>
<style scoped>
.custom-marker {
  width: 25px;
  height: 25px;
  border-radius: 100%;
}

.grid {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0rem;
  margin-left: 0rem;
  margin-top: 1rem;
}

.custom-background {
  background-color: #f0f2f4;
}

.col-8 {
  flex: 0 0 auto;
  padding: 0.5rem;
  width: 66.6667%;
}

.col-4 {
  flex: 0 0 auto;
  padding: 0.5rem;
  width: 33.3333%;
}

.col-12 {
  flex: 0 0 auto;
  padding: 0.5rem;
  width: 100%;
}

.col-6 {
  flex: 0 0 auto;
  padding: 0.5rem;
  width: 50%;
}

.header {
  color: white;
  background-color: #00434d;
}

p {
  font-weight: 400;
}

.warning-message {
  font-size: small;
  color: red;
}
</style>
